// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"bc157d3f","455":"a79be12c","977":"4b9f9eb5"}[chunkId] + ".chunk.js";
};